import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../config/supabase';

const ForceLogout: React.FC = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState('Initializing emergency logout...');

  useEffect(() => {
    const performLogout = async () => {
      try {
        setStatus('Clearing local storage...');
        // Clear all local storage first
        localStorage.clear();
        sessionStorage.clear();

        setStatus('Signing out from Supabase...');
        // Direct Supabase logout - bypass AuthContext
        const { error } = await supabase.auth.signOut();
        if (error) {
          console.error('ForceLogout: Supabase logout error:', error);
          setStatus('Supabase logout failed, but continuing...');
        } else {
          setStatus('Successfully signed out from Supabase');
        }

        setStatus('Redirecting to login page...');
        // Small delay to show final status
        setTimeout(() => {
          navigate('/login', { replace: true });
        }, 1500);

      } catch (error) {
        console.error('ForceLogout: Exception during logout:', error);
        setStatus('Error occurred, but redirecting to login...');
        // Still redirect even if everything fails
        setTimeout(() => {
          navigate('/login', { replace: true });
        }, 1500);
      }
    };

    performLogout();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow rounded-lg sm:px-10">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-red-500 mx-auto mb-4"></div>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">Emergency Logout</h2>
            <p className="text-sm text-gray-600 mb-4">
              {status}
            </p>
            <div className="text-xs text-gray-500">
              This page forces logout and clears all cached data. Use when stuck in loading.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForceLogout;